import { t } from '@if/core/i18n'
import { SnackbarProvider, useSnackbar } from 'notistack'
import { useMemo, type ReactNode } from 'react'

export const useNotification = () => {
  const { enqueueSnackbar } = useSnackbar()
  return useMemo(
    () => ({
      showSuccess: (message?: string) =>
        enqueueSnackbar(message ?? t('common.messages.success'), { variant: 'success' }),
      showError: (message?: string) => enqueueSnackbar(message ?? t('common.messages.error'), { variant: 'error' }),
    }),
    [enqueueSnackbar],
  )
}

interface Props {
  children: ReactNode
}

const NotificationProvider = ({ children }: Props) => {
  return (
    <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }} dense>
      {children}
    </SnackbarProvider>
  )
}

export default NotificationProvider
